var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrowRight = function SvgDoubleArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.893 4.672a.7.7 0 0 0-.99.99L14.24 10l-4.338 4.338a.7.7 0 1 0 .99.99l4.833-4.833a.7.7 0 0 0 0-.99zm-5.834 0a.7.7 0 1 0-.99.99L8.408 10l-4.339 4.338a.7.7 0 1 0 .99.99l4.833-4.833a.7.7 0 0 0 0-.99z",
    clipRule: "evenodd"
  })));
};
export default SvgDoubleArrowRight;